import { AsyncStateStatus } from '../root.types'
import { RelationshipsData } from '../../services/relationships.service'

export enum RelationshipsTypes {
    RELATIONSHIPS_REQUEST = '@relationships/relationshipsRequest',
}

export interface IActionRelationshipsRequest {
    readonly cpfs: string
    readonly cnpjs: string
    readonly merge?: boolean   // true = expandir grafo existente, false/undefined = busca nova
}

export interface IRelationshipsState {
    readonly status: AsyncStateStatus
    readonly data: RelationshipsData | null
}

export interface RelationshipsState {
    request: IRelationshipsState
}
